import * as React from 'react';
import { Modal } from 'react-bootstrap';
const Spinner = require('react-spinkit');

type Props = {
  show: boolean;
};

type State = {
  show: boolean;
};

export class SpinnerModal extends React.Component<Props, {}> {
  state: State  = {
    show: this.props.show
  };

  componentWillReceiveProps(nextProps: Props) {
    this.setState({
      show: nextProps.show
    });
  }

  handleClose = () => {
    console.log('spinner modal closing....');
  }

  render() {
    console.log(`spinner modal is rendering and show: ${this.state.show}`);
    if (!this.state.show) {
      return null;
    }
    
    return (
      <Modal 
        show={this.state.show} 
        onHide={this.handleClose}
        className="spinner-modal"
        keyboard={false}
        backdrop="static"
      >
        <div className="spinner-container">
          <Spinner name="ball-spin-fade-loader" color="white" fadeIn="none" />
        </div>  
      </Modal> 
    );
  }
}
